import React from "react";
import { cn } from "@/lib/utils";

// Dual-arc progress ring.
//  green  = items the owner has verified complete
//  orange = items a sub sent back, awaiting the owner's verification
export function ProgressRing({ total = 0, green = 0, orange = 0, red = 0, size = 48, stroke = 5, className }) {
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const gLen = total ? (green / total) * c : 0;
  const oLen = total ? (orange / total) * c : 0;
  const rLen = total ? (red / total) * c : 0;
  const greenPct = total ? Math.round((green / total) * 100) : 0;
  const orangePct = total ? Math.round((orange / total) * 100) : 0;
  const pct = Math.min(100, greenPct + orangePct);
  const labelColor = red > 0 ? "text-rose-500" : green === 0 && orange > 0 ? "text-amber-500" : "text-emerald-500";

  return (
    <div
      className={cn("relative shrink-0", className)}
      style={{ width: size, height: size }}
      data-testid="progress-ring"
      data-has-issue={red > 0 ? "true" : "false"}
    >
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="hsl(var(--muted))" strokeWidth={stroke} />
        {rLen > 0 && (
          <circle
            cx={size / 2} cy={size / 2} r={r} fill="none"
            stroke="#f43f5e" strokeWidth={stroke} strokeLinecap="round"
            strokeDasharray={`${rLen} ${c - rLen}`} strokeDashoffset={-(gLen + oLen)}
          />
        )}
        {oLen > 0 && (
          <circle
            cx={size / 2} cy={size / 2} r={r} fill="none"
            stroke="#f59e0b" strokeWidth={stroke} strokeLinecap="round"
            strokeDasharray={`${oLen} ${c - oLen}`} strokeDashoffset={-gLen}
          />
        )}
        {gLen > 0 && (
          <circle
            cx={size / 2} cy={size / 2} r={r} fill="none"
            stroke="#10b981" strokeWidth={stroke} strokeLinecap="round"
            strokeDasharray={`${gLen} ${c - gLen}`} strokeDashoffset={0}
          />
        )}
      </svg>
      <div className="absolute inset-0 flex items-center justify-center">
        <span className={cn("font-heading font-bold", labelColor)} style={{ fontSize: size * 0.28 }}>{pct}%</span>
      </div>
    </div>
  );
}
